export const duration150 = '150ms';
export const duration200 = '200ms';
export const duration300 = '300ms';
export const duration450 = '450ms';
export const linear = 'linear';
export const easeIn = 'cubic-bezier(0.4, 0, 1, 1)';
export const easeOut = 'cubic-bezier(0, 0, 0.2, 1)';
export const easeInOut = 'cubic-bezier(0.4, 0, 0.2, 1)';
export default {
  linear,
  easeIn,
  easeOut,
  easeInOut,
  duration150,
  duration200,
  duration300,
  duration450
};
//# sourceMappingURL=animation.js.map